import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function FeatureStyles(params = {}) {
    const { palette, MobileBreakpoint } = params;
    const { initial, initialText } = palette.primary;

    return {
        "& .feature": {
            display: "grid",
            gridGap: "16px",
            gridTemplateRows: "max-content 1fr",
            width: "320px",
            padding: "32px",
            backgroundColor: palette.primary.initial,
            color: palette.primary.initialText,

            pointerEvents: "none",

            "& .feature-image, .feature-image img": {
                maxWidth: "100%",
                height: "48px",
                pointerEvents: "none",

                [MobileBreakpoint]: {
                    height: "48px !important",
                    maxWidth: "none",
                },
            },

            "& .feature-texts": {
                display: "grid",
                gridGap: "16px",

                "& .feature-header": {},
                "& .feature-text": {},
            },

            [MobileBreakpoint]: {
                display: "flex",
                width: "100% !important",
            },
        },

        // ----- Variant 1 -----
        "& .offer-variant-1": {
            color: initialText,
            backgroundColor: initial,
            borderRadius: "20px",
        },

        // ----- Variant 2 -----
        "& .offer-variant-2": {
            backgroundColor: "#ffffff",
            color: initialText,
            border: `4px solid ${initial}`,
            borderRadius: "20px",
        },

        // ----- Variant 3 -----
        "& .offer-variant-3": {
            backgroundColor: "#ffffff",
            color: initialText,
            border: `8px solid ${initial}`,
        },

        // ----- Variant 4 -----
        "& .offer-variant-4": {
            backgroundColor: initial,
            color: initialText,
        },
    };
}

export default function Feature(props) {
    const LI = useLoremIpsum();

    const { header, text, image } = props;

    if (!header && !text) {
        return null;
    }

    const variant = props.variant || 1;
    const CNFeatures = ["feature", `offer-variant-${variant}`];
    const elProps = toElementProps(props, { className: CNFeatures });

    return (
        <div {...elProps}>
            {image && (
                <div className="feature-image">
                    <img src={image} alt="" />
                </div>
            )}

            <div className="feature-texts">
                <h2 className="feature-header">{header || LI.Features[0].header}</h2>
                <div className="feature-text">{text || LI.Features[0].text}</div>
            </div>
        </div>
    );
}
